var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigitalMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "74px",
    height: "74px",
    viewBox: "0 0 74 74",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "73B3AA86-549E-4F54-95D6-F4333EB37677") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dealer-success-program",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dealer-support-desktop",
    transform: "translate(-381.000000, -765.000000)",
    stroke: "#000000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(346.000000, 730.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "digital-media",
    transform: "translate(36.000000, 36.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.53469826,42.425 L26.7240426,42.425 C27.8286121,42.425 28.7240426,43.3204305 28.7240426,44.425 L28.7240426,61.7678571 C28.7240426,62.8724266 27.8286121,63.7678571 26.7240426,63.7678571 L9.53469826,63.7678571 C8.43012876,63.7678571 7.53469826,62.8724266 7.53469826,61.7678571 L7.53469826,44.425 C7.53469826,43.3204305 8.43012876,42.425 9.53469826,42.425 Z",
    id: "Path",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 37.7308489,
    y1: 62.6483516,
    x2: 63.7482402,
    y2: 62.6483516,
    id: "Path-2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4678438,33.1428571 L8.56326969,33.1428571 C7.99520537,33.1428571 7.53469826,32.5339644 7.53469826,31.7828571 L7.53469826,17.5028571 C7.53469826,16.7517499 7.99520537,16.1428571 8.56326969,16.1428571 L62.8208266,16.1428571 C63.3888909,16.1428571 63.8493981,16.7517499 63.8493981,17.5028571 L63.8493981,31.7828571 C63.8493981,32.5339644 63.3888909,33.1428571 62.8208266,33.1428571 L53.9558619,33.1428571",
    id: "Path",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    x: 0.183022774,
    y: 0,
    width: 70.9565217,
    height: 72,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4153611,53.9808327 L16.0583217,57.9140799 C15.5698787,58.2162908 14.9289271,58.06532 14.6267162,57.576877 C14.5250017,57.4124828 14.4711204,57.2229923 14.4711204,57.0296757 L14.4711204,49.1631814 C14.4711204,48.5888053 14.9367442,48.1231814 15.5111204,48.1231814 C15.704437,48.1231814 15.8939275,48.1770627 16.0583217,48.2787772 L22.4153611,52.2120244 C22.9038041,52.5142353 23.054775,53.1551869 22.752564,53.6436299 C22.667798,53.7806314 22.5523627,53.8960667 22.4153611,53.9808327 Z",
    id: "Triangle",
    opacity: 0.95,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    strokeLinejoin: "round",
    fillRule: "nonzero",
    points: "63.7482402 40.6152885 46.9203275 27.7732985 46.9203275 47.2462527 53.0520462 43.3533552 57.3974967 51.8418699 60.7636633 50.5388753 56.4182128 42.0503606"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 37.7308489,
    y1: 56.2197802,
    x2: 63.7482402,
    y2: 56.2197802,
    id: "Path-2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.183022774,
    y1: 10.6636246,
    x2: 71.1395445,
    y2: 10.6636246,
    id: "Path-2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.53469826,
    y1: 5.18439199,
    x2: 33.5040526,
    y2: 5.18439199,
    id: "Path-2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 55.5063492,
    y1: 5.18439199,
    x2: 63.9077985,
    y2: 5.18439199,
    id: "Path-2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 43.6996204,
    y1: 5.18439199,
    x2: 52.1010697,
    y2: 5.18439199,
    id: "Path-2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalMedia);
export default __webpack_public_path__ + "static/media/digital-media.195a92c21f7e7d7210754613b9d4da99.svg";
export { ForwardRef as ReactComponent };